module.exports = __webpack_public_path__ + "static/media/spicy_house_bowl.2afce419.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dish_image/spicy_house_bowl.jpg
// module id = 163
// module chunks = 0